import React from 'react';
import { Container } from 'react-bootstrap';
import Products from './Products';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const RecentlyViewed = ({ products }) => {
    if (!products || products.length === 0) {
        return null;
    }

    return (
        <section className="recently-viewed-section" style={{ marginTop: '0', paddingTop: '0', marginBottom: '2rem' }}>
            <Container style={{ paddingTop: '0' }}>
                <div className="section-header" style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <h2 className="section-title" style={{
                        fontSize: '1.6rem',
                        fontWeight: '500',
                        background: 'linear-gradient(135deg, #3E6D9C 0%, #FD7014 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}>
                        Recently Viewed
                    </h2>
                    <p style={{ color: '#666', fontSize: '1rem' }}>
                        Products you've checked out
                    </p>
                </div>

                <Swiper
                    modules={[Pagination]}
                    spaceBetween={15}
                    slidesPerView={2}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 20
                        },
                        1200: {
                            slidesPerView: 5,
                            spaceBetween: 20
                        }
                    }}
                    style={{ paddingBottom: '40px' }}
                >
                    {products.map((product, index) => (
                        <SwiperSlide key={product._id}>
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                            >
                                <Products product={product} showDiscount={product.isClearance} hideReviews={true} />
                            </motion.div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Container>
        </section>
    );
};

export default RecentlyViewed;